import React from 'react';

import SubPageLayout from '../components/templates/SubPageLayout';
import Layout from '../components/templates/Layout';
import CompanyPage from '../components/pages/CompanyPage';

const Company = () => (
  <Layout>
    <SubPageLayout title="회사소개">
      <CompanyPage />
    </SubPageLayout>
  </Layout>
);

export default Company;
